// src/components/Header.tsx

import * as React from 'react';
import { PagingInfo, WithSearch, Sorting } from '@elastic/react-search-ui';
import { useTenant } from '../context/ThemeContext';
import { Link } from 'react-router-dom';
import { AppBrandLogo } from './AppBrandLogo';
import { LogoutButton } from './LoginGate/LoginGate';

interface HeaderProps {
  showFilterChips?: boolean;
}  

export const Header: React.FC<HeaderProps> = ({ showFilterChips = false }) => {
  const { tenant } = useTenant();

  return (
    <header className="sticky top-0 z-50 w-full bg-mp-bg">
      <div className="pt-3 pb-2">
        {/* Top row: branding + chassis count + logout */}
        <div className="items-center whitespace-nowrap pb-2 hidden lg:flex">
          <div className="w-[280px] shrink-0 px-6">
            <Link to="/">
              <AppBrandLogo size="xl" />
            </Link>
          </div>
          <div className="flex-1 flex justify-end items-center gap-6 px-6">
            <PagingInfo
              view={({ totalResults }) => (
                <span className="font-mono text-sm text-mp-muted uppercase tracking-wider">
                  {totalResults > 0
                    ? `${totalResults} ${tenant.meta.tagline}`
                    : ''
                  }
                </span>
              )}
            />
            {/* Only renders on analytics.mynextclassic.net */}
            <LogoutButton />
          </div>
        </div>

        {/* Mobile header */}
        <div className="flex items-center justify-between lg:hidden pb-3 mb-3 px-4">
          <Link to="/">
            <AppBrandLogo size="base" />
          </Link>
          <div className="flex items-center gap-4">
            <PagingInfo
              view={({ totalResults }) => (
                <span className="font-mono text-xs text-mp-muted uppercase tracking-wider">
                  {totalResults > 0 ? `${totalResults}` : ''}
                </span>
              )}
            />
            {/* Only renders on analytics.mynextclassic.net */}
            <LogoutButton />
          </div>
        </div>
      </div>
    </header>
  );
};
